import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout/layout"
import PageTitle from "../components/page-title"
import { Container, Row } from "reactstrap"
import KIDS from "../components/menu/kids-menu/kids"
import MenuPdf from "../pdf/Ribs-Usa-Menu.pdf"

const KidsMenu = () => {
  return (
    <Layout>
      <SEO
        title="Kids Menu"
        keywords="ribsusabbq, ribs usa, ribs usa bbq, ribs, usa, bbq, best bbq near me, baby back ribs, beef ribs near me, best beef ribs near me, bbq chicken near me"
      />
      <PageTitle title="Kids Menu" />
      <section id="list-menu">
        <Container>
          <Row className="up-menu">
            <div className="col-12 col-sm-12">
              <div className="text-center">
                <a
                  className="btn my-button"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={MenuPdf}
                  download
                >
                  <span className="myover">Download Our Menu</span>
                </a>
              </div>
            </div>
          </Row>

          <div className="item-show">
            <KIDS />
          </div>
        </Container>
      </section>
    </Layout>
  )
}

export default KidsMenu
